import type { FluxErrorEntityErrorCodes } from '../../types.js';

export const AutomationV2ExecutionActionResubmitForApprovalCodes = {
  AutomationV2ExecutionActionResubmitForApprovalFailed: {
    code: 'automation-v2-execution-action/resubmit-for-approval-failed',
    explanation: `Falha ao tentar retornar a aprovação para o status pendente.

**Causas comuns:**
- A aprovação não possui status de "alterações solicitadas"
- A revisão já foi concluída ou cancelada
- Problemas técnicos ao atualizar o status

**Como resolver:**
Verifique se a aprovação está de fato com status de "alterações solicitadas".`,
    localizations: {},
    message: 'A automação não conseguiu reenviar a aprovação.',
    supportingDocs: [
      {
        name: 'Ação de Reenviar para Aprovação',
        path: '/wiki/docs/automations/actions/resubmit-solicitation',
      },
    ],
  },
  AutomationV2ExecutionActionResubmitForApprovalMissingCardId: {
    code: 'automation-v2-execution-action/resubmit-for-approval-missing-card-id',
    explanation: `ID do card é obrigatório para esta ação.

**Causas comuns:**
- Variável cardId não resolvida ou nula no contexto da automação.

**Como resolver:**
Certifique-se de que o ID do card está sendo passado corretamente através do contexto ou mapeamento manual.`,
    localizations: {},
    message: 'Não foi possível reenviar para aprovação porque o ID do card está faltando.',
    supportingDocs: [
      {
        name: 'Ação de Reenviar para Aprovação',
        path: '/wiki/docs/automations/actions/resubmit-solicitation',
      },
    ],
  },
  AutomationV2ExecutionActionResubmitForApprovalNoLastReview: {
    code: 'automation-v2-execution-action/resubmit-for-approval-no-last-review',
    explanation: `O card precisa ter uma aprovação em andamento para poder reenviá-la.

**Causas comuns:**
- O card nunca teve uma solicitação de aprovação
- A aprovação já foi concluída ou cancelada

**Como resolver:**
Verifique se o card possui uma aprovação com status de "alterações solicitadas".`,
    localizations: {},
    message:
      'Não foi possível reenviar para aprovação porque o card não possui uma aprovação ativa.',
    supportingDocs: [
      {
        name: 'Ação de Reenviar para Aprovação',
        path: '/wiki/docs/automations/actions/resubmit-solicitation',
      },
    ],
  },
} as const satisfies FluxErrorEntityErrorCodes<'automation-v2-execution-action'>;
